import {ApiBase} from "./api-base"

export default class AdminApi extends ApiBase {
    static async login(username: string, password: string): Promise<any> {
        return await this.doApiCall("post", "/admin/login", {username, password})
    }

    static async validateHash(hash: string): Promise<any> {
        return await this.doApiCall("post", "/admin/validate-hash", {hash})
    }

    static async updateRoom(roomId: string, data: any): Promise<any> {
        return await this.doApiCall("post", "/admin/room/" + roomId, {data})
    }

    static async getSettings(): Promise<any> {
        return await this.doApiCall("get", "/admin/settings")
    }

    static async updateSettings(settings: any): Promise<any> {
        return await this.doApiCall("post", "/admin/settings", {settings})
    }

    static async getExportData(date: string, page: number = 0, pageSize = 10): Promise<any> {
        return await this.doApiCall("get", "/admin/export?date=" + date + "&page=" + page + "&pageSize=" + pageSize)
    }

    static async downloadExportPDF(date: string): Promise<any> {
        return await this.doApiCall("post", "/admin/export-pdf", {date}, {responseType: "arraybuffer"})
    }

    static async downloadUsersCSV(): Promise<any> {
        return await this.doApiCall("post", "/admin/export-users-csv")
    }

    static async getBookings(date: string): Promise<any> {
        const response = await this.doApiCall("get", "/admin/bookings?date=" + date)
        if (response.bookings) {
            return response.bookings
        } else {
            throw new Error("could not get bookings")
        }
    }
}
